import { render, staticRenderFns } from "./PropSelectGroup.vue?vue&type=template&id=001c97a8&scoped=true"
import script from "./PropSelectGroup.vue?vue&type=script&lang=ts"
export * from "./PropSelectGroup.vue?vue&type=script&lang=ts"
import style0 from "./PropSelectGroup.vue?vue&type=style&index=0&id=001c97a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c97a8",
  null
  
)

export default component.exports